<template>
  <div>
    <b-modal
      id="modal-role"
      ref="my-modal"
      cancel-variant="outline-secondary"
      ok-title="Save"
      :ok-disabled="user_type === 'super-admin'"
      cancel-title="Close"
      centered
      :title="$t('DEBTIA_API_TOKEN_DETAILS')"
      size="lg"
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="modalLoads === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-form>
          <validation-observer
            ref="apiTokenForm"
            tag="form"
          >
            <b-row>
              <b-col
                v-if="details.id !== 0"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CLIENT_ID')"
                  label-for="apiToken"
                  class="mb-2"
                >
                  <b-form-input
                    id="apiToken "
                    v-model="details.client_id"
                    type="text"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="details.id !== 0"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_API_TOKEN_SECRET')"
                  label-for="apiToken"
                  class="mb-2"
                >
                  <b-form-input
                    id="apiToken "
                    v-model="details.secret"
                    type="text"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_TITLE')"
                  label-for="title"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <b-form-input
                      id="title"
                      v-model="details.name"
                      type="text"
                      :placeholder="$t('DEBTIA_TITLE')"
                      :readonly="user_type === 'super-admin'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_DESCRIPTION')"
                  label-for="description"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="description"
                    rules="required"
                  >
                    <b-form-textarea
                      id="textarea-rows"
                      v-model="details.description"
                      :placeholder="$t('DEBTIA_DESCRIPTION')"
                      rows="8"
                      :readonly="user_type === 'super-admin'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BOverlay, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
import constants from '@/app-configs/constants'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  props: {
    apiTokensData: {
      type: Object,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      snowOption: {
        theme: 'snow',
      },
      required,
      details: {},
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
    }
  },
  watch: {
    apiTokensData: {
      handler() {
        this.details = { ...this.apiTokensData }
      },
    },
  },
  methods: {
    submitHandler(evt) {
      evt.preventDefault()
      this.$refs.apiTokenForm.validate().then(success => {
        if (success) {
          let url = ''
          if (this.details.id > 0) {
            url = `${constants.baseUrl}/api-token/update/${this.details.id}`
          } else {
            url = `${constants.baseUrl}/api-token/create`
          }
          axios.post(url, { ...this.details }).then(response => {
            if (response.status === 200) {
              this.$nextTick(() => {
                this.$refs['my-modal'].toggle('#toggle-btn')
              })
              this.details = {
                id: 0, apiToken: '', name: '', description: '', parent_id: JSON.parse(localStorage.getItem('userData')).data.id,
              }
              this.reloadMethod()
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">

</style>
